//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import activateSortFilter from '~/mixins/ResourceSortFunctions/sort.js';
export default {
	props: ['query'],
	mixins: [activateSortFilter],
	computed: {
		...mapState({
			filterDropdown: ({ dropdownStore: {filterDropdown} }) => filterDropdown,
			filter: ({ filtersStore: { filter } }) => filter,
		}),
	},
}
